import { ReactSortable } from 'react-sortablejs';
import PhotoAlertBox from './PhotoAlertBox';
import PhotoCardList from './PhotoCardList';

const PhotosContainer = ({
  isMobile,
  baseUrl,
  orderedPhoto,
  disaproovedPhotos,
  tempAproovedPhoto,
  tempDisaproovedPhoto,
  setShowBottomButtons,
  setOrderedPhoto,
  photoCheckboxHandler,
}) => (
  <>
    {!!orderedPhoto?.length && (
      <>
        <ReactSortable
          animation={500}
          draggable='.card-sortable'
          filter='.handle-sortable-filtered'
          id='sortable'
          className='row cards-object row-cols-3 row-cols-xl-4 row-cols-xxl-5 g-2'
          disabled={isMobile}
          onChange={setShowBottomButtons}
          list={orderedPhoto}
          setList={setOrderedPhoto}
          preventOnFilter={false}
        >
          <PhotoCardList
            checkBoxHandler={photoCheckboxHandler}
            checkedArray={tempAproovedPhoto}
            data={orderedPhoto}
            baseUrl={baseUrl}
            uncheckedArray={tempDisaproovedPhoto}
            isAproovePhoto
          />
        </ReactSortable>
      </>
    )}
    {!!disaproovedPhotos?.length && (
      <>
        <PhotoAlertBox className='alert-dark small'>
          Отказано в публикации, {disaproovedPhotos?.length} фото:
        </PhotoAlertBox>
        <div className='row cards-object row-cols-3 row-cols-xl-4 row-cols-xxl-5 g-2'>
          <PhotoCardList
            baseUrl={baseUrl}
            checkBoxHandler={photoCheckboxHandler}
            checkedArray={tempDisaproovedPhoto}
            uncheckedArray={tempAproovedPhoto}
            data={disaproovedPhotos}
          />
        </div>
      </>
    )}
  </>
);

export default PhotosContainer;
